import { Typography } from "@mui/material";
import React from "react";
import NumberChip from "./NumberChip";

export default function NumberedTitle({ number = "-", title }) {
  return (
    <Typography
      sx={{ display: "flex", fontSize: "1.2rem", alignItems: "center", my: 2 }}
    >
      <NumberChip number={number} /> {title} :
    </Typography>
  );
}
